<template>
  <div class="flex items-center gap-4 mb-4">
    <div
        v-if="number"
        class="w-12 h-12 rounded-full bg-golden-grass text-marshland-950 flex items-center justify-center text-xl font-bold"
    >
      {{ number }}
    </div>
    <h3 class="text-2xl font-semibold text-golden-grass-400">{{ title }}</h3>
  </div>
  <p class="mb-6 text-marshland-300">
    <slot name="description">{{ description }}</slot>
  </p>
</template>

<script setup lang="ts">
defineProps<{
  number?: string
  title: string
  description: string
}>()
</script>
